import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useRef } from 'react';
import { styled } from 'styletron-react';
import { staticColors } from '../../../const/colors/staticColors';
import { sizes } from '../../../const/sizes';
import { getSpacing } from '../../../const/spacing';
import { transitionDuration } from '../../../const/transitionDuration';
import { useIsInputFocused } from '../../../hooks/useIsInputFocused';
import { useTestIdAttribute } from '../../../hooks/useTestIdAttribute';
import { Icon } from '../../Icon/Icon';
import { useTextStyle } from '../../Text/useTextStyle';
import { INPUT_TEXT_VARIANT } from '../useInputStyles';
const StyledSearchContainer = styled('div', (p) => ({
    display: 'flex',
    alignItems: 'center',
    gap: getSpacing(),
    overflow: 'hidden',
    padding: getSpacing(),
    borderColor: p.$isFocused
        ? staticColors.inputFocusedBorder
        : staticColors.inputBackground,
    borderStyle: 'solid',
    borderWidth: sizes.searchInput.borderWidth,
    borderRadius: sizes.input.borderRadius,
    backgroundColor: staticColors.inputBackground,
    caretColor: staticColors.inputCaret,
    transitionProperty: 'border-color',
    transitionDuration: transitionDuration.short,
}));
const StyledSearchInput = styled('input', (p) => ({
    ...p.$textStyle,
    flexGrow: 1,
    padding: 0,
    margin: 0,
    backgroundColor: 'transparent',
    border: 'none',
    outline: 'none',
}));
export const SearchInput = forwardRef(({ rightAdornment, onBlur, onFocus, disabled, readOnly, testId, ...inputProps }, passedRef) => {
    const localRef = useRef(null);
    const ref = passedRef ?? localRef;
    const { isFocused, handleBlur, handleFocus } = useIsInputFocused({
        onBlur,
        onFocus,
        disabled,
        readOnly,
    });
    const textStyle = useTextStyle({
        font: 'primary',
        variant: INPUT_TEXT_VARIANT,
        color: 'dark',
        underline: false,
    });
    const testIdAttribute = useTestIdAttribute(testId);
    const handleContainerClick = () => {
        typeof ref === 'object' && ref?.current?.focus();
    };
    return (_jsxs(StyledSearchContainer, { $isFocused: isFocused, onClick: handleContainerClick, children: [_jsx(Icon, { name: 'Search' }), _jsx(StyledSearchInput, { ref: ref, $textStyle: textStyle, disabled: disabled, readOnly: readOnly, onBlur: handleBlur, onFocus: handleFocus, ...inputProps, ...testIdAttribute }), rightAdornment] }));
});
